export default "<p>amfredirect works!</p>\n";